import React, { Component } from 'react'
import {TableCell} from 'react-toolbox/lib/table'
import * as R from 'ramda'
import { IconButton } from 'react-toolbox/lib/button'
import { userURL } from 'config'
import Tag from 'components/display/Tag'
import { TAG_COLORS } from 'components/display/Tag/constants'

import Table from 'containers/Manage/Table'
import StatusChip from 'containers/Project/NvqualSection/Chip'

import styles from './styles.scss'


const ActionButton = ({ id }) =>  {
  const url = new URL(`project/${id}/view?action=nvqual_approval`, userURL)
  return <IconButton
      primary
      theme={styles}
      icon='launch'
      onClick={() => window.open(url, `_blank`).focus()}
      />
}

const tableHeadContent = Object.freeze({
  projectId: <TableCell key={0}>Project ID</TableCell>,
  name: <TableCell key={1}>Project Name</TableCell>,
  partnerSiteName: <TableCell key={2}>Partner Site</TableCell>,
  platform: <TableCell key={3}>Platform</TableCell>,
  sku: <TableCell key={4}>SKU</TableCell>,
  brand: <TableCell key={5}>Brand</TableCell>,
  nvqualResultName: <TableCell key={6}>Approval Status</TableCell>,
  pendingCounts: <TableCell key={7}>Pending Reviews</TableCell>,
  action: <TableCell key={8}>Action</TableCell>
})

const renderTag = (nvqualResultName) => {
  return <StatusChip text={nvqualResultName} />
}

const enhanceSource = () => R.map(({id, pendingCounts, nvqualResultName, ...rest}) => {
  
  
    return {
    ...rest,
    nvqualResultName: renderTag(nvqualResultName),
    pendingCounts: pendingCounts == 0 ? `None`: `${pendingCounts} Revisions`,
    action: <ActionButton id={id} />
  }
})

const TableComponent = ({onClick, source, ...rest}) => {
  const props = {
    tableHeadContent, 
    source: enhanceSource()(source)
  }
  return <Table {...rest}{...props} />
}

export default TableComponent
